<ng-container *ngIf="isLoading">
    <div class="loading" [ngClass]="cssClass" [style.width]="">
    </div>
</ng-container>

<ng-container *ngIf="!isLoading">
    <ng-container *ngTemplateOutlet="templateRef"></ng-container>
</ng-container>